import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import {isEmpty} from "lodash";
import FaqItem from "./FaqItem";

export default function FaqList({
  faqs = [], ...props
}) {
  if (isEmpty(faqs))
    return null;

  return <div>
    {faqs.map((faq, index) => <FaqItem key={index} faq={faq} />)}
  </div>

}
